import { Component } from 'react'
import _ from 'lodash'
import {
  SUBSTATION_ID,
  PRODUCT_SHIP_TYPE
} from '@vzmi/shp_shared_compo/constants/proposal'
import { getIsThresholdFreebie } from '@vzmi/shp_shared_compo/helpers/proposalHelpers'
import { getFeatureToggle } from '@vzmi/component_ec_nodejs_util/dist/lib/FeatureToggleUtil'
import { Modal, Tip } from '@vzmi/shp_shared_compo'
import {
  getAttrTransientKey,
  getAttrTableFieldPrefixByLevel,
  getScopedFieldNameByShipType
} from '../../Common/ProposalForm/Shared/util'
import {
  LISTING_IS_THRESHOLD_FREEBIE,
  TRANSIENT_FIELD_KEY,
  SHIP_TYPE_FORM_SECTION_NAME
} from '../../Shared'
import {
  FormRow,
  InputCountField,
  RadioGroupInputField,
  HyperLink
} from '../../../Common/Form'
import { Field, FormValueSelector } from '../../../Common/forms'
import SingleLineText from '../../Common/ReadOnlyComponents/SingleLineText/SingleLineText'
import { ListingFieldConfig } from '../../Common/ProposalForm/Shared/FieldConfig'
import { IconPopoverLabel } from '../../Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import { RADIO_DEFAULT_TYPES } from '../../../../constants/proposalTypes'
import { SHIP_TYPE_ID_FIELD_NAME } from '../../../../lib/ReduxFormSelectors/ProposalListingForm'
import styles from './MoreInfo.css'

const BOOK_SUB_STATION = `sub${SUBSTATION_ID.BOOK}`

const NewProductLink = () => (
  <HyperLink
    href='/proposal/newProduct/compose'
    target='_blank'
  >
    新增贈品/配件/屬性
  </HyperLink>
)

const IsThresholdFreebieModel = ({ isPM, ...props }) => (
  <Modal
    title={'您提案的賣場商品為「滿額贈活動贈品」'}
    cancelButtonVisible={false}
    className='is-threshold-freebie-modal'
    {...props}
  >
    <p>
      此賣場商品，僅可做為滿額贈活動的贈品搭贈，無法於前台供消費者購買，
      若非滿額贈活動贈品，請使用「
      <NewProductLink />
      」功能，新增贈品即可。
    </p>
    {
      isPM && (
        <>
          <br />
          <Tip
            type='info'
            className={styles.isThresholdFreebieTip}
          >
            將連動賣場為不顯示。
          </Tip>
        </>
      )}
  </Modal>
)

class MoreInfo extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isThresholdFreebieModalVisible: false,
      currentDeliveryType: null
    }
  }

  componentDidUpdate (prevProps) {
    const { shipTypeFormSection: prevShipTypeFormSection } = prevProps
    const { shipTypeFormSection } = this.props

    if (!_.isEqual(prevShipTypeFormSection, shipTypeFormSection)) {
      this.handleDeliveryTypeChange()
    }
  }

  handleShowOrderChange = async (e, value) => {
    const { change, isPM } = this.props
    if (isPM) {
      change('listing.isDisplay', !value)
    }

    if (!value) {
      return
    }

    this.setState({ isThresholdFreebieModalVisible: true })
  }

  handleIsThresholdFreebieModelCancel = () => this.setState({ isThresholdFreebieModalVisible: false })

  getIsShowOrderOption = () => {
    const { currentDeliveryType } = this.state
    const {
      product = {},
      transient,
      subStationId,
      isListingProposal,
      shipType
    } = this.props
    const { catItemId, struDataAttrClusterId } = product
    // 新增提案時選擇的屬性要從 redux form 下面的路徑找
    // __transient__.attribute.subStationId_catItemId_struDataAttrClusterId.table.[withLevel|withoutLevel].specs
    const attrTransientKey = getAttrTransientKey(subStationId, catItemId, struDataAttrClusterId)
    const attrTransient = _.get({ [TRANSIENT_FIELD_KEY]: transient }, attrTransientKey, {})
    const attrTableFieldPrefixByLevel = getAttrTableFieldPrefixByLevel(attrTransient.hasSpecLevel)
    const specs = _.get(attrTransient, `${attrTableFieldPrefixByLevel}.specs`, [])
    // 判斷顯示滿額贈選項，且須為新增提案
    return getIsThresholdFreebie(
      specs,
      currentDeliveryType,
      shipType,
      true
    ) && isListingProposal
  }

  resetShowOrderValue = () => {
    const { productShowOrder, change } = this.props
    // 滿額贈已經是 false 時不用再條整
    if (!productShowOrder) {
      return
    }

    change(LISTING_IS_THRESHOLD_FREEBIE, false)
  }

  handleDeliveryTypeChange = () => {
    const { shipTypeFormSection, shipType } = this.props
    const currentDeliveryType = _.get(
      { shipTypeFormSection },
      getScopedFieldNameByShipType(shipType, 'listing.deliveryType')
    )
    this.setState({ currentDeliveryType })
  }

  render () {
    const {
      isThresholdFreebieModalVisible
    } = this.state
    const {
      readOnly,
      isNewProposal,
      subStationId,
      mustShowFormError,
      flags,
      isPM,
      product
    } = this.props
    // 配合其他欄位連動決定滿額贈是否顯示
    const isShowOrderOption = this.getIsShowOrderOption()
    // readOnly 狀態(檢視頁、確認頁)因為已經不可能有其他欄位造成連動，所以也不需要調整
    // 檢視頁進入時預設值會讓 getIsShowOrderOption 判斷成要隱藏
    // 如果滿額贈是 true 會因此被改成 false
    if (!isShowOrderOption && !readOnly) {
      this.resetShowOrderValue()
    }

    // 若配送方式為[電子票券]，滿額贈贈品選項disable
    const isShipTypeIsEVoucher = (_.get(product, 'shipType.id', '') === PRODUCT_SHIP_TYPE.E_VOUCHER)

    return (
      <div
        className={styles.moreInfoArea}
        data-role='more-info'
      >
        <FormRow
          className={styles.moreInfo}
          label='更多資訊'
        />
        <FormRow
          label='品牌'
          // 2024/10/14 TODO: 2025 Q1 才會全面替換 暫時先改回品牌
          // label={(
          //   <IconPopoverLabel
          //     popoverContent='ESD 配送方式專用'
          //   >
          //     ESD 專用品牌
          //   </IconPopoverLabel>
          // )}
          subTitle='(非必填)'
        >
          <Field
            {...ListingFieldConfig.getField('product.brand')}
            className={styles.advanceInput}
            component={
              readOnly
                ? SingleLineText
                : InputCountField
            }
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
        <FormRow
          label='商品型號'
          subTitle='(非必填)'
          withInputCountPaddingBottom
        >
          <Field
            {...ListingFieldConfig.getField('product.model')}
            className={styles.advanceInput}
            component={
              readOnly
                ? SingleLineText
                : InputCountField
            }
            showErrorOnActive={isNewProposal}
            mustShowFormError={mustShowFormError}
          />
        </FormRow>
        {
          (
            BOOK_SUB_STATION === subStationId &&
            getFeatureToggle(flags, 'sp_ProductTaxType')
          ) && (
            <FormRow
              key='productTaxFree'
              label='免稅商品'
              labelAlign='top'
              withInputCountPaddingBottom
            >
              <Field
                name='product.taxFree'
                data-role='product-taxFree'
                component={RadioGroupInputField}
                disabled={readOnly}
                options={RADIO_DEFAULT_TYPES}
                showErrorOnActive={isNewProposal}
                mustShowFormError={mustShowFormError}
              />
            </FormRow>
          )}
        {
          isShowOrderOption && (
            <FormRow
              key='isThresholdFreebie'
              label={(
                <IconPopoverLabel
                  popoverContent={(
                    <>
                      非滿額贈活動贈品，請使用「
                      <NewProductLink />
                      」功能，新增贈品即可
                    </>
                  )}
                >
                  滿額贈活動贈品
                </IconPopoverLabel>
              )}
              labelAlign='top'
              withTopTip
              withInputCountPaddingBottom
            >
              <Field
                name={LISTING_IS_THRESHOLD_FREEBIE}
                data-role='listing-is-threshold-freebie'
                component={RadioGroupInputField}
                disabled={readOnly || isShipTypeIsEVoucher}
                options={RADIO_DEFAULT_TYPES}
                onChange={this.handleShowOrderChange}
                showErrorOnActive={isNewProposal}
                mustShowFormError={mustShowFormError}
              />
            </FormRow>
          )}
        <IsThresholdFreebieModel
          visible={isThresholdFreebieModalVisible}
          onOk={this.handleIsThresholdFreebieModelCancel}
          onCancel={this.handleIsThresholdFreebieModelCancel}
          isPM={isPM}
        />
      </div>
    )
  }
}

const FormValueMoreInfo = props => (
  <FormValueSelector
    selector={select => ({
      shipType: select(SHIP_TYPE_ID_FIELD_NAME),
      shipTypeFormSection: select(SHIP_TYPE_FORM_SECTION_NAME),
      transient: select(TRANSIENT_FIELD_KEY),
      product: select('product'),
      subStationId: select('subStationId'),
      readOnly: select('setting.readOnly'),
      productShowOrder: select(LISTING_IS_THRESHOLD_FREEBIE),
      isPM: select('setting.user.identity.isPM'),
      mustShowFormError: select('mustShowFormError')
    })}
  >
    {values => (
      <MoreInfo
        {...props}
        {...values}
      />
    )}
  </FormValueSelector>
)

export default FormValueMoreInfo
